export enum RoleEnum {
	Admin = "admin",
	Manager = "manager",
	Operator = "operator",
}
